import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TreeOption } from '@rivethealth/data/options';
import { identity } from 'lodash';
import { ObservableInput } from 'observable-input';
import { combineLatest, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { AnalyticsEventOutput } from '../analytics/common-analytics.service';
import { Loadable } from '../helpers/loadable';
import { FiltersComponent } from './filters.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'filter-tree-multi-select',
  templateUrl: './filter-tree-multi-select.component.html',
  styleUrls: ['./filter-tree-multi-select.component.scss'],
})
export class FilterTreeMultiSelectComponent<Name extends string, T> {
  constructor(
    private readonly filtersComponent: FiltersComponent<{ [K in Name]: T[] }>,
  ) {}

  @Input() options: TreeOption[] = [];

  @Input()
  name: Name;

  @Input()
  loadable: Loadable<any> | null = null;

  @Input()
  readonly analyticsEvents: {
    clicked?: AnalyticsEventOutput<void>;
  } = {
    clicked: () => {},
  };

  clickAnalytics() {
    if (this.analyticsEvents.clicked) {
      this.analyticsEvents.clicked();
    }
  }

  @Input()
  @ObservableInput()
  generalize!: Observable<(ids: T[]) => T[]>;

  @Input()
  @ObservableInput()
  resolve!: Observable<(ids: T[]) => T[]>;

  readonly selected = combineLatest([
    this.filtersComponent.value.pipe(map(value => [...value[this.name]])),
    this.resolve.pipe(startWith(identity)),
  ]).pipe(map(([v, resolve]) => resolve(v)));

  changeSelected = this.generalize.pipe(
    startWith(identity),
    map(generalize => (value: T[]) => {
      this.filtersComponent.changeValue.next({
        name: this.name,
        reduce: () => generalize(value)!,
      });
    }),
  );
}
